import * as jose from 'jose';

export interface Recipient {
  alg: string;
  publicKey: jose.JWK;
}

export default async function encryptPayload(
  crypto: Crypto,
  recipients: Recipient[],
  payload: string
) {
  const subtle = crypto.subtle;

  const encodedMessage = new TextEncoder().encode(payload);
  const messageDigest = await subtle.digest('SHA-256', encodedMessage);
  const messageHash = jose.base64url.encode(new Uint8Array(messageDigest));

  const digest = {
    m: 'SHA-256',
    v: messageHash,
  };

  const message = new jose.GeneralEncrypt(encodedMessage)
    .setProtectedHeader({
      enc: 'A256GCM',
      digest,
    })
    .setSharedUnprotectedHeader({});

  for (const { alg, publicKey } of recipients) {
    const importedPublicKey = await jose.importJWK(publicKey, alg);
    message.addRecipient(importedPublicKey).setUnprotectedHeader({ alg });
  }

  const jwe = await message.encrypt();

  return jwe;
}
